import { useEffect, useState } from "react";
import { DataTable } from "../../../components/data-table";
import { dataDecrypt, encrypt } from "../../../app/utility/encryption-helper";
import { ApisService } from "../../../app/core/apis.service";
import { useNavigate, useParams } from "react-router-dom";
import { UsersDataGridCols } from "./data-grid-cols";

export const OrgUsers = () => {
  const params = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [organizationUsersData, setOrganizationUsersData] = useState<any>([]);
  const [inputValue, setInputValue] = useState("");
  const initialPayload = { id: params.org, filters: { limit: 10, page: 0 } }
  const [pageCount, setPageCount] = useState<any>(initialPayload);

  useEffect(() => {
    loadUsers(initialPayload);
  }, []);

  async function loadUsers(data: any): Promise<void> {
    setLoading(true);
    try {
      let encrytedData = encrypt(JSON.stringify(data));
      const res = await ApisService.usersApi("findByBuId", encrytedData);
      const userData = JSON.parse(dataDecrypt(res.data.data));
      const response = userData.results;
      response.forEach((el: any) => {
        el.details = <button className="px-4 primary-bg text-white rounded border-0 py-1">Details</button>
      });
      setOrganizationUsersData(userData);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  const onSelectPaginator = (data: any) => {
    const pageData = { ...pageCount, page: data };
    let payload = { id: params.org, filters: { limit: pageData.filters.limit, page: data, name: inputValue } }
    setPageCount(payload);
    loadUsers(payload);
  };

  const onActions = (data: any) => {
    if (data.type === "view") {
      navigate(`/dashboard/organizations/org-details/${params.page}/${params.org}/users/${data?.data?._id}/info`)
    }
  }

  const handleChange = (e: any) => {
    let payload = { id: params.org, filters: { limit: 10, page: 0, name: e.target.value } };
    loadUsers(payload);
    setInputValue(e.target.value);
  }

  return (
    <div className="px-3">
      <div className="row">
        <div className="my-3 px-0">
          <input type="text" className="form-control rounded-pill" value={inputValue} onChange={handleChange} placeholder="Search ..." />
        </div>
      </div>

      {loading && (
        <div className="text-center p-5">
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      )}
      {!loading && (
        <>
          <DataTable
            tableData={organizationUsersData}
            TableCols={UsersDataGridCols}
            pagination={true}
            pageCount={pageCount}
            onSelectPageChange={(e) => onSelectPaginator(e)}
            onActions={(e) => onActions(e)}
          />
        </>
      )}
    </div>
  );
};
